import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box, Checkbox, Divider } from '@mui/material';

//*files
import cssClasses from './SustenancePriceList.module.css';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';
import Button from '../../../Subcomponents/Button';
import { cloneDeep, differenceWith, isEqual, sortBy, uniqBy } from 'lodash';
import {
  DeleteSelectedPrices,
  getAllPricingForSustenance,
  getAllProjectPrice,
  getProjectByProjectName,
  PricingRelationsData,
  SaveSelectedPrices,
} from '../../../Services/SustenanceService';
import { errorTost, successTost } from '../../../Services/Toast';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { getAllPricingByProject } from '../../../Services/PaymentPlans';
import SelectSalesCp from '../../SelectSalesCp/SelectSalesCp';

function SustenancePriceList() {
  const dispatch = useDispatch();
  const [allPriceList, setAllPriceList] = useState([]);
  const [allChildPriceList, setAllChildPriceList] = useState([]);
  const [searchPriceList, setSearchPriceList] = useState('');
  const [projectName, setProjectName] = useState('');
  const { projectId } = useParams();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);

  useEffect(() => {
    dispatch(action.activeMenu('pricelist'));
    getProjectData();
    console.log("all-Price-List" , allPriceList.length)
  }, []);

  function getProjectData() {
    getProjectByProjectName(projectId).then((resp) => {
      console.log('Projects-Data', resp.data[0].projectName);
      setProjectName(resp.data[0]);
    });
  }

  useEffect(() => {
    if (allPriceList.length === 0) {
      presentLoader();
      getAllPricingByProject(projectId)
        .then((resp) => {
          console.log('project-Pricing', resp.data);
          resp.data.forEach((ele, index) => {
            ele.id = ele.projectPricingId;
            ele.show = true;
            ele.index = index;
            ele.isSelected = false;
            ele.wingName = ele.wingId.wingName;
            ele.startDateTime = ele.startDateTime
              ? new Date(ele.startDateTime).toDateString() +
                ',' +
                new Date(ele.startDateTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : 'Default';
            ele.endDateTime = ele.endDateTime
              ? new Date(ele.endDateTime).toDateString() +
                ',' +
                new Date(ele.endDateTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : 'Default';
          });
          console.log(resp.data);
          getAllProjectPrice(projectId)
            .then((res) => {
              console.log("sustenance-price-relations" , res)
              if (res.data.length > 0) {
                res.data.forEach((ele, index) => {
                  resp.data[
                    resp.data.findIndex(
                      (e) => e.projectPricingId === ele.projectPricingId
                    )
                  ].isSelected = true;
                  resp.data = sortBy(resp.data, [
                    function (o) {
                      return !o.isSelected;
                    },
                  ]);
                  let newarr = cloneDeep(resp.data);
                  if (index === res.data.length - 1) {
                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                    setAllChildPriceList([...resp.data]);
                    setAllPriceList([...newarr]);
                    dismissLoader();
                  }
                });
              } else {
                let newarr = cloneDeep(resp.data);
                setAllChildPriceList([...resp.data]);
                setAllPriceList([...newarr]);
                dismissLoader();
              }
            })
            .catch((err) => {
              let newarr = cloneDeep(resp.data);
              setAllChildPriceList([...resp.data]);
              setAllPriceList([...newarr]);
              dismissLoader();
            });
        })
        .catch((err) => {
          dismissLoader();
        });
    } else {
      if (searchPriceList === '') {
        allChildPriceList.forEach((e, index) => {
          setAllChildPriceList((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
        allPriceList.forEach((e, index) => {
          setAllPriceList((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
      } else {
        allPriceList.forEach((ele) => {
          if (
            !ele.title.toUpperCase().includes(searchPriceList.toUpperCase())
          ) {
            setAllChildPriceList((pre) => {
              pre[
                pre.findIndex(
                  (e) => e.projectPricingId === ele.projectPricingId
                )
              ].show = false;
              return [...pre];
            });
            setAllPriceList((pre) => {
              pre[
                pre.findIndex(
                  (e) => e.projectPricingId === ele.projectPricingId
                )
              ].show = false;
              return [...pre];
            });
          } else {
            setAllChildPriceList((pre) => {
              pre[
                pre.findIndex(
                  (e) => e.projectPricingId === ele.projectPricingId
                )
              ].show = true;
              return [...pre];
            });
            setAllPriceList((pre) => {
              pre[
                pre.findIndex(
                  (e) => e.projectPricingId === ele.projectPricingId
                )
              ].show = true;
              return [...pre];
            });
          }
        });
        setAllChildPriceList(
          sortBy(allChildPriceList, [
            function (o) {
              return !o.isSelected;
            },
          ])
        );
      }
    }
  }, [searchPriceList]);

  function SavePricing() {
    let allExistingPriceList = allPriceList.filter((e) => {
      return e.isSelected === true;
    });
    let arr = allChildPriceList.filter((e) => {
      return e.isSelected === true;
    });
    if (arr.length === 0) {
      let newarr = cloneDeep(allPriceList)
      setAllChildPriceList([...newarr])
      errorTost("Please select atleast one Price  and then save")
    } else {
      let newarr = cloneDeep(allChildPriceList);
    setAllPriceList([...newarr]);
    presentLoader();
    if (allExistingPriceList.length > 0) {
      let insertarr = differenceWith(arr, allExistingPriceList, isEqual);
      let deletearr = differenceWith(allExistingPriceList, arr, isEqual);
      if (insertarr.length > 0) {
        insertarr.forEach((element, index) => {
          SaveSelectedPrices({
            projectId: projectId,
            projectPricingId: element.projectPricingId,
          }).then((resp) => {
            setAllPriceList((pre) => {
              pre[
                pre.findIndex(
                  (e) => e.projectPricingId === element.projectPricingId
                )
              ].isSelected = true;
              return [...pre];
            });
            if (index === insertarr.length - 1) {
              if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedPrices(ele, projectId).then((res) => {
                    if (index2 === deletearr.length - 1) {
                      setAllPriceList((pre) => {
                        pre[
                          pre.findIndex(
                            (e) =>
                              e.projectPricingId === element.projectPricingId
                          )
                        ].isSelected = false;
                        return [...pre];
                      });
                      successTost('PriceList saved successfully');
                      setSearchPriceList('');
                      dismissLoader();
                    }
                  });
                });
              } else {
                successTost('PriceList saved successfully');
                setSearchPriceList('');
                dismissLoader();
              }
            }
          });
        });
      } else if (deletearr.length > 0) {
        deletearr.forEach((ele, index2) => {
          DeleteSelectedPrices(ele, projectId).then((res) => {
            if (index2 === deletearr.length - 1) {
              setAllPriceList((pre) => {
                pre[
                  pre.findIndex(
                    (e) => e.projectPricingId === ele.projectPricingId
                  )
                ].isSelected = false;
                return [...pre];
              });
              successTost('PriceList saved successfully');
              setSearchPriceList('');
              dismissLoader();
            }
          });
        });
      } else {
        successTost('PriceList saved successfully');
        setSearchPriceList('');
        dismissLoader();
      }
    } else {
      arr.forEach((ele, index) => {
        SaveSelectedPrices({
          projectId: projectId,
          projectPricingId: ele.projectPricingId,
        }).then((resp) => {
          setAllPriceList((pre) => {
            pre[
              pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)
            ].isSelected = true;
            return [...pre];
          });
          if (index === arr.length - 1) {
            successTost('PriceList saved successfully');
            setSearchPriceList('');
            dismissLoader();
          }
        });
      });
    }
    }
  
    // }
  }

  const PriceGridColumns = [
    {
      field: 'title',
      headerName: 'Title',
      width: 250,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.isSelected}
                onChange={(e) => {
                  setAllChildPriceList((pre) => {
                    pre[
                      pre.findIndex((e) => e.id === params.row.id)
                    ].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)]
                        .isSelected;
                    return [...pre];
                  });
                }}
              />
            </div>
            <div>
              <p>{params.row.title}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: 'wingName',
      headerName: 'Wing',
      width: 250,
    },
    {
      field: 'startDateTime',
      headerName: 'Start Date Time',
      width: 250,
    },
    {
      field: 'endDateTime',
      headerName: 'End Date Time',
      width: 250,
    },
  ];


  function selectAll() {
    setAllChildPriceList((pre) => {
      pre.forEach((ele, index) => {
        pre[index].isSelected = true;
      });
      return [...pre];
    });
  }

  function deSelectAll() {
    setAllChildPriceList((pre) => {
      pre.forEach((ele, index) => {
        pre[index].isSelected = false;
      });
      return [...pre];
    });
  }

  return (
    <Box className={cssClasses.Container}>
      <Box  padding={'2rem'}>
        <Box className={cssClasses.HeaderTitle}>{projectName?.projectName}</Box>
        <Box className={cssClasses.SubTitle}>
          {projectName?.addressLine1},{projectName?.addressLine2},
          {projectName?.addressLine3}
        </Box>
      </Box>

      <Divider variant='middle' />

      <Box overflow={'auto'} height={'100%'}>
        <Box
          className={cssClasses.FlexRow}
          marginTop={'2rem'}
          padding={'0 2.4rem'}
        >
          <Box className={cssClasses.SubHeaderTitle}>Select Price List</Box>
          {loggedInUser?.roleId?.accessibleTabs?.Sustenance['Price List'][
            'Price List Save'
          ]?.isAccessible && (
            <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#1570EF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Roboto-Regular",
                }}
                padding={'0.8rem 2.6rem'}
                disable={allPriceList.length === 0}
                btnName={'Save'}
                clicked={SavePricing}
              />
            </Box>
          )}
        </Box>

        <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
          <SelectSalesCp
           
            allChildRows={allChildPriceList}
            allRows={allChildPriceList.filter((e) => {
              return e.show === true;
            })}
            selectAll={selectAll} deSelectAll={deSelectAll}
            allColums={PriceGridColumns}
            setSearchSalesCp={setSearchPriceList}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SustenancePriceList;
